export const ACCOUNT_DELETION_STEP_MAP = {
  verifyAccount: 'verify-account',
  guideToUnsubscribe: 'guide-to-unsubscribe',
  confirmWithSubscription: 'confirm-with-subscription',
  confirmWithoutSubscription: 'confirm-without-subscription',
} as const
